import styled from '@emotion/styled';

export const Image = styled.div<{ url: string }>`
  background: black ${({ url }) =>
      'url("' + url}") no-repeat fixed center/contain;
  height: 100vh;
  width: 100vw;
`;
